import {useNavigate} from "react-router-dom";
import IdentityImage from "../../IdentityImage.jsx";
import {useRouteList} from "../../../Routing.jsx";
import PlanName from "../../../pages/project/Subscription/PlanName.jsx";
import React from "react";
import {replaceProjectIdInPath} from "../../../utils/projectRouting.js";

export default function UserDropdownProjectItem({project, setCurrentProjectId, isCurrent}) {

    const [routeList] = useRouteList();
    let navigate = useNavigate();

    let newPath = replaceProjectIdInPath(window.location.pathname, project.id);

    let exists = false;
    for (let route of routeList) {
        if (route.path === newPath) {
            exists = true;
        }
    }

    if (!exists) {
        newPath = '/';
    }

    const subscriptionCode = project?.subscription?.currentPackage?.code;

    return (
        <li className="hover:bg-indigo-100 dark:hover:bg-indigo-100/10">
            <span
                className="
                    font-medium text-sm text-slate-700 dark:text-gray-200
                    block py-1.5 px-3 cursor-pointer select-none
                 "

                onClick={() => {
                    setCurrentProjectId(project.id);
                    navigate(newPath);
                }}
            >
                <div className="flex items-center justify-between">
                    <div className="grow flex items-center truncate">
                        <IdentityImage url={project.logoUrl} project={project} className={'mr-2'}/>
                        <div className="truncate leading-4">
                            <div className="font-bold">{project.name}</div>
                            <div className="mt-0.5">
                                <PlanName
                                    planCode={subscriptionCode}
                                    withoutSubscription={!project?.subscription}
                                    className={'px-1.5 py-0.4 inline-flex items-center rounded-md bg-gray-50 text-xs font-medium text-gray-600 ring-1 ring-gray-500/10 ring-inset dark:bg-transparent dark:text-gray-300 dark:ring-gray-600'}
                                />
                            </div>
                        </div>
                    </div>
                    {isCurrent &&
                        <svg className="w-3 h-3 shrink-0 fill-current text-violet-500 dark:text-violet-400 ml-4"
                             viewBox="0 0 12 12">
                            <path
                                d="M10.28 1.28L3.989 7.575 1.695 5.28A1 1 0 00.28 6.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 1.28z"/>
                        </svg>
                    }
                </div>
            </span>
        </li>
    );
}

